import React, { useState } from 'react'
import TextFieldUniversal from '../../../../../validate/form/text/TextFieldUniversal'

const SupplyOrderItemCountField = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Кількість'} 
        placeholder={'1'}
        validates={{
            isEmpty: true,
            // isDigit: true
            isNumber: true
        }}
        forciblyValue={forciblyValue}
        required={required}
        // classNameAdd={'w200'}
		
    />
  )
}

export default SupplyOrderItemCountField